import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-burial-header',
  templateUrl: './burial-header.component.html',
  styleUrls: ['./burial-header.component.scss']
})
export class BurialHeaderComponent {
  @Input() isLoading: boolean = false;
  @Input() isApplicationOnline: boolean = false;
  @Input() currentLocationName: string = '';
  @Input() locations: any[] = [];
  @Input() totalBurials: number = 0;

  @Output() newContractClick = new EventEmitter<void>();
  @Output() locationChange = new EventEmitter<string>();
  @Output() importContractClick = new EventEmitter<void>();
  @Output() searchClick = new EventEmitter<void>();
  @Output() filterClick = new EventEmitter<void>();

  onNewContractClick() {
    this.newContractClick.emit();
  }

  onLocationChange(event: any) {
    this.locationChange.emit(event.target.value);
  }

  onImportContractClick() {
    this.importContractClick.emit();
  }

  onSearchClick() {
    this.searchClick.emit();
  }

  onFilterClick() {
    this.filterClick.emit();
  }
} 